import React, { Component , Fragment } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

class CounterOne extends Component{
    state = {
        didViewCountUp: false
    };
    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({didViewCountUp: true});
        }
    }
    render(){
        let Data = [
            {
                countNum : 116615,
                countTitle: 'TMS Treatments Performed',
            },
            {
                countNum : 28476,
                countTitle: 'Total Ketamine Treatment Patients',
            },
            {
                countNum : 5409584,
                countTitle: '$$ worth of free care given to the community',
            },
        ];

        return(
            <Fragment>
                <div>
                    <h2 style={{textAlign: "center", color: "white"}}>Redemption Psychiatry Cares</h2>
                </div>
                <div className="row">
                    {Data.map( (value, index) => (
                        <div className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                            <h5 className="counter">
                                <VisibilitySensor onChange={this.onVisibilityChange} offset={{top:10}} delayedCall>
                                    <CountUp  separator=","  end={this.state.didViewCountUp ? value.countNum : 0} />
                                </VisibilitySensor>
                            </h5>
                            <p className="description">{value.countTitle}</p>
                        </div>
                    ))}
                </div>
            </Fragment>
        )
    }
}
export default CounterOne;